/**
 * Parse SPD "tanggal" string (Indonesian) → return end date.
 * Supports formats like:
 *  - "5 - 15 Jan 26"     → Jan 15, 2026
 *  - "3 - 10 Apr 26"     → Apr 10, 2026
 *  - "5 Mei 26"          → May 5, 2026
 *  - "12 - 21 Jan 2026"  → Jan 21, 2026
 */
const MONTH_MAP = {
  jan: 0, januari: 0,
  feb: 1, februari: 1,
  mar: 2, maret: 2,
  apr: 3, april: 3,
  mei: 4, may: 4,
  jun: 5, juni: 5, june: 5,
  jul: 6, juli: 6, july: 6,
  ags: 7, agst: 7, agt: 7, agustus: 7, aug: 7, august: 7,
  sep: 8, sept: 8, september: 8,
  okt: 9, oct: 9, oktober: 9, october: 9,
  nov: 10, november: 10,
  des: 11, dec: 11, desember: 11, december: 11,
};

function normalizeMonth(m) {
  if (!m) return null;
  const key = m.toLowerCase().replace(/[^a-z]/g, "");
  return MONTH_MAP[key] ?? null;
}

export function parseSpdEndDate(raw) {
  if (!raw || typeof raw !== "string") return null;
  const cleaned = raw.trim().replace(/\s+/g, " ");

  // Range with two days
  let m = cleaned.match(/(\d{1,2})\s*[-–]\s*(\d{1,2})\s+([A-Za-z]+)\.?\s*(\d{2,4})/);
  if (m) {
    const endDay = parseInt(m[2], 10);
    const month = normalizeMonth(m[3]);
    let year = parseInt(m[4], 10);
    if (year < 100) year += 2000;
    if (month === null) return null;
    return new Date(year, month, endDay);
  }

  // Single day
  m = cleaned.match(/(\d{1,2})\s+([A-Za-z]+)\.?\s*(\d{2,4})/);
  if (m) {
    const day = parseInt(m[1], 10);
    const month = normalizeMonth(m[2]);
    let year = parseInt(m[3], 10);
    if (year < 100) year += 2000;
    if (month === null) return null;
    return new Date(year, month, day);
  }

  return null;
}

const OPEN_STATUSES = new Set(["", "Draft", "Berjalan", null, undefined]);

/**
 * Returns overdue info for an SPD record. Overdue = tanggal end < today AND status not final (Selesai/Batal).
 */
export function computeOverdue(record) {
  const status = record?.data?.status;
  if (!OPEN_STATUSES.has(status)) return { overdue: false };
  const endDate = parseSpdEndDate(record?.data?.tanggal);
  if (!endDate) return { overdue: false };
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  const days = Math.floor((now.getTime() - endDate.getTime()) / (1000 * 60 * 60 * 24));
  if (days <= 0) return { overdue: false, endDate };
  return { overdue: true, endDate, daysLate: days };
}
